import type { BlockElement } from '../core/type';

export const ColumnItemElement: BlockElement = ({ children }) => {
  return <>{children}</>;
};
